import { get } from 'axios';
import getAbTarget from 'src/libs/abTesterService/getAbTarget';
import appConfig from 'src/utils/appConfig';
import { reportFlowServiceFailure } from 'src/utils/rollbar';
import { getParsedNodes } from 'src/nodes';
import { DEFAULT_FLOW_ID } from 'src/config/flowConfig';

const requestFlow = (flowId = DEFAULT_FLOW_ID) => {
  const url = `${appConfig.getMyConfig().assetUrl}assets/flows/${flowId}.json`;
  return get(url)
    .then(({ data }) => {
      const parsedNodes = getParsedNodes(data.flow);
      return Object.assign({}, data, { parsedNodes });
    }, (error) => {
      reportFlowServiceFailure(error, flowId, url);
      return Promise.reject(error);
    });
};

const requestAbFlow = (flowId, learnLanguageAlpha3) =>
  getAbTarget(flowId, learnLanguageAlpha3)
    .then((abTestFlowId) =>
      abTestFlowId ? requestFlow(abTestFlowId) : requestFlow(flowId)
    ).catch(() =>
      requestFlow(DEFAULT_FLOW_ID)
    );

export default (flowId, learnLanguageAlpha3, useAbTester) =>
  useAbTester ? requestAbFlow(flowId, learnLanguageAlpha3) : requestFlow(flowId);
